import { render, staticRenderFns } from "./KSRDamageRecording.vue?vue&type=template&id=65d5c4f9&"
import script from "./KSRDamageRecording.vue?vue&type=script&lang=js&"
export * from "./KSRDamageRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports